import { create } from "zustand";
export const useUnregisteredFTNStore = create((set) => ({
  licenses: null,
  setLicenses: (licenses) => set({ licenses }),
}));
